import { Component, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'task-item',
	templateUrl: 'task-item.html'
})
export class TaskItemComponent implements AfterViewInit {

	@Input('data') taskItem: any;
	@Output('onClick') onClick : EventEmitter<any> = new EventEmitter();
	private taskEle: HTMLElement;

	constructor() {
	}

	ngAfterViewInit() {

		setTimeout(() => {

			this.taskEle = document.getElementById(this.taskItem.id);

			var classArray = this.taskItem.classname.split(" ");

			if (classArray && classArray.length > 0) {
				classArray.forEach(element => {
					this.taskEle.classList.add(element);
				});
			}

		}, 100)
	}

	goToTask(item) {
		this.onClick.emit(item);
	}

}



// WEBPACK FOOTER //
// ./src/components/task-item/task-item.ts